/* eslint-disable*/
import VueStoreService from './VueStoreService';
const SaleService = {
    async getSales(url,store){
        var resp = await VueStoreService.get("sales"+url, store)
        return resp;
    },
    async saveSale(data,store){
        var resp = await VueStoreService.post("sale-detail",data,store)
        return resp;
    },
    async getSaleById(sale_id,store){
        var resp = await VueStoreService.get("sale-detail/"+sale_id,store)
        return resp;
    },

    async ValidateQuote(correlative,store){
        var resp = await VueStoreService.get("sale-detail/validate/"+correlative,store)
        return resp;
    },

    async RequestStock (data,store){
        var resp = await VueStoreService.post("sale-detail/makeInternalMovementAutomatic", data,store)
        return resp;
    },

    async updateSale(sale_id,data,store){
        var resp = await VueStoreService.patch("sale-detail/"+sale_id,data,store)
        return resp;
    },

    async deleteSale(sale_id,store){
        var resp = await VueStoreService.delete("sale-detail/"+sale_id,store)
        return resp;
    },
}

export default SaleService;